/** "12 MB", for a size-limit message a user can act on. */
export const formatBytes = (bytes: number): string => {
  if (bytes >= 1024 * 1024) return `${Math.round(bytes / (1024 * 1024))} MB`;
  return `${Math.round(bytes / 1024)} KB`;
};

/**
 * Checks a selection against the panel's upload limits, returning the message
 * to show or `undefined` when everything is acceptable.
 *
 * Both checks run here as well as via the picker's `accept` attribute, because
 * a user can always drag a file past a file-type filter.
 */
export const getUploadRejection = (
  files: FileList,
  { accept, maxFileSize }: { accept?: string[]; maxFileSize?: number }
): string | undefined => {
  const selected = Array.from(files);

  if (maxFileSize) {
    const oversized = selected.find((file) => file.size > maxFileSize);
    if (oversized) {
      return `${oversized.name} is larger than the ${formatBytes(maxFileSize)} limit.`;
    }
  }

  if (accept?.length) {
    const rejected = selected.find((file) => !accept.some((type) => file.type.startsWith(type)));
    if (rejected) {
      return `${rejected.name} is not a file type this shipment accepts.`;
    }
  }

  return undefined;
};
